import Button from '@ui/Button'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { applyEmailVerification, IdpError, type IdpErrorCode } from '@/auth/idp'

import LoginCard from './LoginCard'

// Landing page for the confirmation link in our email.
const VerifyEmail = () => {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const oobCode = params.get('oobCode')
  const [state, setState] = useState<'working' | 'done' | IdpErrorCode>(
    oobCode ? 'working' : 'link-invalid'
  )

  useEffect(() => {
    if (!oobCode) return undefined
    let live = true
    applyEmailVerification(oobCode)
      .then(() => live && setState('done'))
      .catch((err) => {
        if (live) setState(err instanceof IdpError ? err.code : 'unknown')
      })
    return () => {
      live = false
    }
  }, [oobCode])

  return (
    <LoginCard title={t('auth.verify-email.title')}>
      {state === 'working' && (
        <p className="text-sm text-ink-500">{t('auth.verify-email.working')}</p>
      )}
      {state === 'done' && (
        <p className="text-sm text-ink-700">{t('auth.verify-email.done')}</p>
      )}
      {state !== 'working' && state !== 'done' && (
        <p role="alert" className="text-sm text-flag">
          {t(`auth.password.errors.${state}` as const)}
        </p>
      )}
      {state !== 'working' && (
        <Button fullWidth onClick={() => window.location.assign('/login')}>
          {t('auth.password.back-to-sign-in')}
        </Button>
      )}
    </LoginCard>
  )
}

export default VerifyEmail
